import React from 'react';
import AttendeeSessionsList from './AttendeesSessionsList';

export default function PastAttendeeSessionsList(props) {
    return <AttendeeSessionsList {...props} />;
}

PastAttendeeSessionsList.splash = {
    ...AttendeeSessionsList.splash,
    defaultProps: {
        ...AttendeeSessionsList.splash.defaultProps,
        descendants: {
            ...AttendeeSessionsList.splash.defaultProps.descendants,
            sessionButton: {
                ...AttendeeSessionsList.splash.defaultProps.descendants.sessionButton,
                meta: { content: 'Watch Now' },
            },
        },
    },
};

PastAttendeeSessionsList.propTypes = AttendeeSessionsList.propTypes;
PastAttendeeSessionsList.defaultProps = AttendeeSessionsList.defaultProps;
